import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import CentralizedLoginPage from "./Components/Login/CentralizedLoginPage";
import AuthUser from "./Components/Login/AuthUser";
import MainLayout from "./Components/Layout/MainLayout";
import Dashboard from "./Components/Dashboard/Dashboard";
import ForgotPassword from "./Components/Login/ForgotPassword";

const App = () => {
	return (
		<Router>
			<Routes>
				{/* Login Page */}
				<Route path="/" element={<CentralizedLoginPage />} />
				<Route path="/AuthUser/:appId" element={<AuthUser />} />
				<Route path="/Forgot-Password" element={<ForgotPassword />} />

				{/* Protected Routes with Sidebar */}
				<Route
					path="/dashboard"
					element={
						<MainLayout>
							<Dashboard />
						</MainLayout>
					}
				/>
			</Routes>
		</Router>
	);
};

export default App;
